// import the required animation functions from the angular animations module
import { animate, state, style, transition, trigger } from '@angular/animations';

export const RouteStateAnimation =
  // trigger name for attaching this animation to an element using the [@triggerName] syntax
  trigger('routeState', [
    state(
      'inactive',
      style({
        opacity: 0
      })
    ),
    state(
      'active',
      style({
        opacity: 1
      })
    ),
    transition('inactive => active', animate('100ms ease-in'))
  ]);
